/**
 * Procedure Categories and Procedures for MD in Emergency Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 12-14: "Procedural skills: Minimum number of procedures that a candidate needs to perform")
 */
export const EMERGENCY_MEDICINE_PROCEDURES = {
  "Airway, Resuscitation & Life Support Procedures": [
    "Basic & Advanced Airway Management (Opening Airway, Bag-Mask Ventilation)",
    "Tracheal Intubation & Alternative Airway Procedures (Surgical & Non-Surgical)",
    "Pediatric & Neonatal Airway Management",
    "Basic & Advanced Cardiopulmonary Resuscitation (CPR / ACLS / PALS / NALS / ATLS)",
    "Cardioversion, Defibrillation & Electric Therapy",
    "Temporary Cardiac Pacing & Cardiac Compression",
    "Invasive Mechanical Ventilation & Ventilator Management",
    "Intra-Osseous & Central Venous Access",
  ],
  "Trauma, Resuscitative & Invasive Surgical Procedures": [
    "Intercostal Chest Tube Insertion & Tube Thoracostomy",
    "Needle Thoracentesis",
    "Emergency Department (ED) Thoracotomy",
    "Surgical & Needle Cricothyroidotomy",
    "Pericardiocentesis",
    "Abdominal & Diagnostic Paracentesis",
    "Lumbar Puncture",
    "Suprapubic Catheterization & Foley's Catheterization",
    "Arterial Puncture",
    "Gastric Lavage & Skin/Eye Decontamination",
    "Nasogastric (NG) Tube Insertion",
    "Patient Transportation & Transfer (Intra-Hospital & Inter-Hospital)",
  ],
  "Wound, Orthopaedic & Emergency Specialty Procedures": [
    "Wound Preparation, Debridement & Closure Techniques (Suturing & Dressing)",
    "Soft Tissue Foreign Body Removal",
    "Splinting, Spinal Immobilization, Logrolling & Cervical Collar Application",
    "Traction Splints & Plaster Cast Techniques for Fractures",
    "Reduction of Dislocations, Fasciotomy & Pelvic Stabilization",
    "Joint Aspiration (Arthrocentesis)",
    "ENT Emergency Procedures (Nasal Packing, Foreign Body Removal, Laryngoscopy & Tracheostomy Care)",
    "Dental Anaesthesia & Dental Socket Suturing",
    "Ocular Emergency Procedures (Lateral Canthotomy, Foreign Body Removal, IOP Measurement)",
    "Emergency Obstetrics Procedures (Conduct of Delivery & Perimortem Caesarean Section)",
    "Urological & Scrotal Procedures (Reducing Paraphimosis & Detorsion of Torsion of Testis)",
    "Incision & Drainage of Abscess",
    "Local, Regional & Nerve Block Anaesthesia & Procedural Sedation",
  ],
  "Point of Care Ultrasound (POCUS) & Emergency Imaging Procedures": [
    "Trauma Ultrasound (FAST / E-FAST Examination)",
    "Focused Cardiac Ultrasound (Focused ECHO / Cardiac Arrest POCUS / TEE)",
    "Pulmonary & Airway Ultrasound Assessment",
    "Abdominal & Renal POCUS",
    "Soft Tissue, Skin, Joint & Fracture Assessment Ultrasound",
    "Ocular Ultrasound & Intracranial Pressure Measurement",
    "Ultrasound-Guided Procedural Guidance",
  ],
};

export const EMERGENCY_MEDICINE_CATEGORIES = Object.keys(EMERGENCY_MEDICINE_PROCEDURES);

export const isMDInEmergencyMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("emergency medicine") || d.includes("casualty") || d.includes("emergency");
};
